<template>
    <div class="row justify-content-between align-items-center">
        <div class="col-auto">
            <span
                class="back--button"
                @click="prev"
                v-if="!unavailable"
            >
                <i class="fas fa-chevron-left"></i>
            </span>
        </div>
        <div class="col-auto">
            <span
                class="back--button"
                v-if="unavailable"
                @click="goDashboard"
                >Painel</span
            >
        </div>
    </div>
</template>

<script>
export default {
    methods:{
        goDashboard(){
            this.$emit('goDashboard');
        },
        prev(){
            this.$emit('prev')
        }
    },
    props: {
        unavailable:{
            required: true
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/CheckoutHeader.vue